import { useNavigate, useParams } from "react-router";

const pagePaths = {
  rfqs: "/teams/:teamSlug/rfqs",
  organizations: "/teams/:teamSlug/organizations",
  rfq: "/teams/:teamSlug/rfqs/:rfqId",
  part: "/teams/:teamSlug/rfqs/:rfqId/parts/:partId",
  quote: "/teams/:teamSlug/rfqs/:rfqId/quote",
  send: "/teams/:teamSlug/rfqs/:rfqId/send",
  done: "/teams/:teamSlug/rfqs/:rfqId/done",
  settings: "/teams/:teamSlug/settings",
  profile: "/teams/:teamSlug/profile",
};

export function getUrl(
  type: keyof typeof pagePaths,
  params: Record<string, string | undefined>,
) {
  return pagePaths[type].replace(
    /:([a-zA-Z_]+)/g,
    (_, key) => params[key] ?? "",
  );
}

export default function useToPage() {
  const navigate = useNavigate();
  const { teamSlug, rfqId: rfqIdParam } = useParams();

  return {
    toRfqs: () => navigate(getUrl("rfqs", { teamSlug: teamSlug! })),
    toRfq: (rfqId?: string) =>
      navigate(
        getUrl("rfq", { teamSlug: teamSlug!, rfqId: (rfqId ?? rfqIdParam)! }),
      ),
    toPart: (partId: string) =>
      navigate(
        getUrl("part", { teamSlug: teamSlug!, rfqId: rfqIdParam!, partId }),
      ),
    toQuote: () =>
      navigate(getUrl("quote", { teamSlug: teamSlug!, rfqId: rfqIdParam! })),
    toSend: () =>
      navigate(getUrl("send", { teamSlug: teamSlug!, rfqId: rfqIdParam! })),
    toDone: () =>
      navigate(getUrl("done", { teamSlug: teamSlug!, rfqId: rfqIdParam! })),
  };
}
